// extracted by mini-css-extract-plugin
export default {"container-desktop":"container-desktop-b444","sm":"sm-cd22","md":"md-59fe","lg":"lg-b3f1","container-mobile":"container-mobile-b330"};